import { useSyncExternalStore } from 'react'

/**
 * How wide the detail panel is: its normal width, or widened.
 *
 * 450px is right for a preview — a few fields and a title. It is wrong for the
 * panels this console actually opens: a grant matrix, an email body, a thread
 * of messages, a subscription list. Those wrap into a column of two-word lines
 * and become unreadable, and most of them have no full page to escape to.
 *
 * So the escape is the panel itself. The choice is remembered because an
 * operator who widened it once wants it wide for the next record too.
 */

const STORAGE_KEY = 'cargo-admin-detail-wide'

let wide = read()
const listeners = new Set<() => void>()

function read(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1'
  } catch {
    // Private-mode storage failures lose the memory, not the toggle.
    return false
  }
}

export function togglePanelWide() {
  wide = !wide
  try {
    localStorage.setItem(STORAGE_KEY, wide ? '1' : '0')
  } catch {
    // As above.
  }
  for (const listener of listeners) listener()
}

export function usePanelWide(): boolean {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener)
      return () => listeners.delete(listener)
    },
    () => wide,
    () => false,
  )
}
